/**
 * Home page only: every link (including header/mobile nav links) opens in a
 * new tab. Other page templates keep default same-tab navigation. Links that
 * just scroll to a section on the home page itself (in-page anchors, or a
 * bare "#") are left alone so they scroll in the same tab instead.
 */
export function initHomeLinksNewTab() {
	document.querySelectorAll('a[href]').forEach((link) => {
		if (isSamePageAnchor(link)) {
			return;
		}

		link.setAttribute('target', '_blank');

		const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
		rel.add('noopener');
		rel.add('noreferrer');
		link.setAttribute('rel', [...rel].join(' '));
	});
}

function isSamePageAnchor(link) {
	if (link.getAttribute('href') === '#') {
		return true;
	}

	return Boolean(link.hash) && link.pathname === window.location.pathname;
}
